export enum WorkbenchEvents {
  KeyboardShortcutsOpened = 'workbench.help.KeyboardShortcutsOpened',
  SidebarCloseWidget = 'workbench.sidebar.CloseWidget',
  SidebarOpenWidget = 'workbench.sidebar.OpenWidget',
  Connect = 'workbench.Connect'
}
